import { render, staticRenderFns } from "./DomHighlight.vue?vue&type=template&id=39a7edc2&scoped=true&"
import script from "./DomHighlight.vue?vue&type=script&lang=js&"
export * from "./DomHighlight.vue?vue&type=script&lang=js&"
import style0 from "./DomHighlight.vue?vue&type=style&index=0&id=39a7edc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7edc2",
  null
  
)

export default component.exports